import {
  IInstructorApprover,
  IError,
  IQueryHookOptions,
  IUpdateInstructorApproverRequest,
} from '@comptia-sso/core';
import {
  UseMutateAsyncFunction,
  useMutation,
  useQueryClient,
} from 'react-query';

// Services.
import { addInstructorApprover, updateInstructorApprover } from 'services';

type UpdateInstructorApproverFunction = UseMutateAsyncFunction<
  IInstructorApprover,
  unknown,
  IUpdateInstructorApproverRequest
>;

type UseUpdateInstructorApprover = [
  UpdateInstructorApproverFunction,
  IQueryHookOptions,
];

export const useUpdateInstructorApprover = (
  instructorApproverId = '',
): UseUpdateInstructorApprover => {
  const queryClient = useQueryClient();
  const { error, isError, isLoading, mutateAsync } = useMutation<
    IInstructorApprover,
    IError,
    IUpdateInstructorApproverRequest
  >(
    (values: IUpdateInstructorApproverRequest) => {
      if (instructorApproverId === '') {
        return addInstructorApprover(values);
      }
      return updateInstructorApprover(instructorApproverId, values);
    },
    {
      onSuccess: (data) => {
        queryClient.setQueryData(
          ['instructor-approvers', instructorApproverId],
          data,
        );
        queryClient.invalidateQueries(['instructor-approvers']);
      },
    },
  );

  return [mutateAsync, { error, isError, isLoading }];
};
